import { gql } from "@apollo/client";

const CHATBOT_ANALYTICS_UPDATED = gql`
  subscription chatbotAnalyticsUpdated(
    $mainSuperAdminId: Int!
    $agentId: Int
    $botId: String
  ) {
    chatbotAnalyticsUpdated(
      mainSuperAdminId: $mainSuperAdminId
      agentId: $agentId
      botId: $botId
    ) {
      agentId
      activeWidgets
      botConversions
      handoffs
      widgetCustomers
      avgConfidenceScore
    }
  }
`;

export default CHATBOT_ANALYTICS_UPDATED;
